<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <h4>Thêm mới yêu cầu xin nghỉ</h4>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="form-card mb-3">
              <el-card class="box-card">
                <div>
                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="160px"
                    label-position="top"
                  >
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Tiêu đề" prop="employee_request.title">
                          <el-input
                            type="text"
                            v-model="mData.dataForm.employee_request.title"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                            ref="title"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <el-form-item
                          v-if="mData.reselectEmployee"
                          label="Nhân viên"
                          prop="employee_request.employee_id"
                        >
                          <el-select
                            filterable
                            v-model="mData.dataForm.employee_request.employee_id"
                            :disabled="!isSelectEmployee"
                            @change="fn_reSelectEmployee"
                          >
                            <el-option
                              v-for="item in filteredRequestEmployees"
                              :key="item.id"
                              :label="fn_setLabelRespectively(item)"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="3" class="m-auto">
                        <p class="mb-1">
                          Số ngày nghỉ có phép còn ({{currentYear}}):
                          {{ fn_roundTo2Digit(remain_allow_dayoff_number_current_year) }}
                        </p>
                        <p>
                          Số ngày nghỉ có phép còn ({{nextYear}}):
                          {{ fn_roundTo2Digit(remain_allow_dayoff_number_next_year) }}
                        </p>
                      </b-col>
                      <b-col md="3" class="m-auto pl-0">
                        <p class="mb-1">
                          Số ngày nghỉ không phép còn ({{currentYear}}):
                          {{ fn_roundTo2Digit(remain_unallow_dayoff_number_current_year) }}
                        </p>
                        <p>
                          Số ngày nghỉ không phép còn ({{nextYear}}):
                          {{ fn_roundTo2Digit(remain_unallow_dayoff_number_next_year) }}
                        </p>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1" v-if="mData.reselectEmployee">
                      <b-col md="6">
                        <el-form-item label="Chi nhánh">
                          <el-select
                            v-model="requestEmployeeFilter.branch_ids"
                            multiple
                            filterable
                            clearable
                            collapse-tags
                            disabled
                            placeholder="Tất cả chi nhánh"
                            @change="fn_resetEmployeeWhenFilteredOut"
                          >
                            <el-option
                              v-for="item in filteredBranchList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Phòng ban">
                          <el-select
                            v-model="requestEmployeeFilter.department_ids"
                            multiple
                            filterable
                            clearable
                            collapse-tags
                            disabled
                            placeholder="Tất cả phòng ban"
                            @change="fn_resetEmployeeWhenFilteredOut"
                          >
                            <el-option
                              v-for="item in filteredDepartmentList"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý trực tiếp"
                          prop="employee_request.level2Approval"
                        >
                          <DirectManagerField
                            v-model="mData.dataForm.employee_request.level2Approval"
                            :options="mData.dataDefault.listQuanLyTrucTiep"
                            :label-builder="fn_setLabelRespectively"
                          />
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Quản lý nhân sự"
                          prop="employee_request.employeeApproval"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="mData.dataForm.employee_request.employeeApproval"
                          >
                            <el-option
                              v-for="(item, index) in listHrApprove"
                              :key="item.e && item.e.id ? item.e.id : index"
                              :label="
                                item.e &&
                                item.e.administrative_info &&
                                item.e.administrative_info.name &&
                                item.e.administrative_info.name.full_name
                                  ? `${item.e.employee_no ? item.e.employee_no : ''} - ${
                                      item.e.administrative_info.name.full_name
                                        ? item.e.administrative_info.name.full_name
                                        : ''
                                    }`
                                  : 'không xác định'
                              "
                              :value="item.e && item.e.id ? item.e.id : ''"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Phân loại" prop="detail_request.type">
                          <el-select
                            clearable
                            v-model="mData.dataForm.detail_request.type"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listLoaiLyDoNghi"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item
                          label="Lý do"
                          prop="detail_request.request_reason_id"
                        >
                          <el-select
                            clearable
                            filterable
                            v-model="mData.dataForm.detail_request.request_reason_id"
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listRequestReason"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row class="mb-1">
                      <b-col md="6">
                        <el-form-item
                          label="Thời gian từ"
                          prop="detail_request.start_date"
                        >
                          <el-date-picker
                            type="date"
                            v-model="mData.dataForm.detail_request.start_date"
                            :disabled="mData.viewMode == 'detail'"
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'dd/MM/yyyy' || 'dd-MM-yyyy'"
                            :picker-options="pickerOptionFrom"
                            @change="fn_tableSearch"
                          >
                          </el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="tới" prop="detail_request.end_date">
                          <el-date-picker
                            type="date"
                            v-model="mData.dataForm.detail_request.end_date"
                            :disabled="mData.viewMode == 'detail'"
                            prefix-icon="isax-calendar-1"
                            :clearable="false"
                            :format="'dd/MM/yyyy' || 'dd-MM-yyyy'"
                            :picker-options="pickerOptionFromTo"
                            @change="fn_tableSearch"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <!-- table day off -->
                    <div
                      class="main-body-table tableFixHead table__shift-off ml-3 mr-3"
                      v-if="isShowTableDayOff"
                    >
                      <table class="table table-hover">
                        <thead>
                          <tr>
                            <th
                              class="tableTh sticky-col first-col"
                              style="vertical-align: middle; z-index: 11"
                            >
                              Ngày
                            </th>
                            <th
                              class="tableTh"
                              v-for="(item, i) in dataTableDate"
                              :key="i"
                            >
                              {{ item }}
                            </th>
                          </tr>
                        </thead>
                        <tbody v-for="(item, index) in dataTable" :key="index">
                          <tr v-for="(row, indx) in item" :key="indx">
                            <td class="table__col-shiftName sticky-col first-col">
                              {{ row.shift_oddName }}
                            </td>
                            <td
                              v-for="(item, i) in row.date"
                              :key="i"
                              class="table__col-shiftOff"
                              max-height="50px"
                            >
                              <b-form-checkbox
                                v-if="item.value != null"
                                value="true"
                                unchecked-value="false"
                                v-model="item.value"
                                @change="
                                  fn_checkDuplicateShiftOff(
                                    row.shift_id,
                                    row.date,
                                    indx,
                                    i,
                                    index
                                  ),
                                  countCheckTotalDayOffCheck(
                                    'checkBox',
                                    indx,
                                    i,
                                    index
                                  )
                                "
                              >
                                Nghỉ
                              </b-form-checkbox>
                              <p
                                v-if="item.value == null"
                                style="font-weight: bold; color: #ff0033"
                              >
                                Ngày nghỉ
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <b-row class="mb-1">
                      <b-col md="12">
                        <el-form-item label="Ghi chú" prop="employee_request.content">
                          <el-input
                            type="textarea"
                            v-model="mData.dataForm.employee_request.content"
                            :disabled="mData.viewMode == 'detail'"
                            resize="none"
                            :autosize="{ minRows: 3, maxRows: 3 }"
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <div class="text-center mt-2">
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-default"
                        @click="fn_submitForm('create')"
                        >Thêm mới</el-button
                      >
                      <el-button
                        v-if="mData.viewMode == 'create'"
                        class="btn-back"
                        @click="fn_goBack"
                        >Quay lại</el-button
                      >
                    </div>
                  </el-form>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MethodService from '../../../../service/MethodService'
import EmployeeRequestApi from '../../../../moduleApi/EmployeeRequestApi'
import EmployeeRequestDayOffApi from '../../../../moduleApi/EmployeeRequestDayOffApi'
import EmployeeShiftApi from '../../../../moduleApi/EmployeeShiftApi'
import ShiftApi from '../../../../moduleApi/ShiftApi'
import DirectManagerField from '../components/DirectManagerField'
import { dataMixins } from '../../ManageRequests/RequestMixins/dataMixins'
import { fnMixins } from '../../ManageRequests/RequestMixins/fnMixins'
export default {
  components: { DirectManagerField },
  mixins: [dataMixins, fnMixins],
  data() {
    return {
      typeReq: 'DAY_OFF',
      isShowTableDayOff: false,
      mData: {
        dataDefault: {
          listEmployeeShift: [],
          listShift: [],
        },
      },
      listDate: [],
      dataTable: [],
      dayoff_timePost: [],
      listEmployeeApprove: [],
      listDayOffNotToReq: [],
      isSelectEmployee: true,
      hasTimeOff: false,
      listReqDayOffToday: [],
      listWork: [],
      countDayOffTick: 0,
    }
  },

  computed: {
    filteredDepartmentList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id
      if (!employeeId) {
        return (this.mData.dataDefault.listDepartment || []).filter(
          dept => dept.company_id === this.currentCompany.id
        )
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId)
      const departmentIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ]

      return (this.mData.dataDefault.listDepartment || []).filter((dept) =>
        departmentIds.includes(dept.id)
      )
    },
    filteredBranchList() {
      const employeeId = this.mData.dataForm.employee_request.employee_id
      if (!employeeId) {
        return (this.mData.dataDefault.listBranch || []).filter(
          branch => branch.company_id === this.currentCompany.id
        )
      }

      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId)
      const branchIds = [
        ...new Set(
          (this.fn_getActiveJobInfo(selectedEmployee) || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ]

      return (this.mData.dataDefault.listBranch || []).filter((branch) =>
        branchIds.includes(branch.id)
      )
    }
  },

  methods: {
    async fn_innitDataDefault() {
      await this.fn_getListEmployee()
      this.fn_getListEmployeeRequestReason(this.typeReq)
      await this.fn_getListEmployeeApprovedQLTT()
      this.fn_getListHoliday()
    },

    async fn_getReqDayOffToday(employeeId) {
      const dataFilter = {
        filters:
          (employeeId ? 'employee_id=' + employeeId : '') +
          '&type=DAY_OFF' +
          '&:or:status=WAITING_FOR_APPROVAL,status=APPROVED' +
          '&created_at>=' +
          new Date(new Date().setHours(0, 0, 0)).toISOString() +
          '&created_at<=' +
          new Date(new Date().setHours(23, 59, 59)).toISOString(),
      }
      this.listReqDayOffToday = []
      const employeeRequestApiRes = await EmployeeRequestApi.list(dataFilter)
      if (employeeRequestApiRes.result.length > 0) {
        employeeRequestApiRes.result.forEach(async (e) => {
          const employeeRequestDayOffApiRes = await EmployeeRequestDayOffApi.findById(
            e.id
          )
          if (employeeRequestDayOffApiRes.result) {
            this.listReqDayOffToday.push(employeeRequestDayOffApiRes.result)
          }
        })
      }
    },

    fn_syncRequestOrgFilterByEmployee(employeeId) {
      if (!employeeId) return
      const selectedEmployee = this.fn_findRequestEmployeeById(employeeId)
      if (!selectedEmployee) return

      const activeJobs = this.fn_getActiveJobInfo(selectedEmployee)
      this.requestEmployeeFilter.department_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.department_id)
            .filter(Boolean)
        ),
      ]
      this.requestEmployeeFilter.branch_ids = [
        ...new Set(
          (activeJobs || [])
            .map((item) => item.branch_id)
            .filter(Boolean)
        ),
      ]

      this.$nextTick(() => {
        this.fn_resetEmployeeWhenFilteredOut()
      })
    },

    async fn_reSelectEmployee() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        return
      }

      this.fn_syncRequestOrgFilterByEmployee(
        this.mData.dataForm.employee_request.employee_id
      )
      await this.fn_initDataShift()
      this.mData.validForm.employee_request.employee_id = []
      this.$nextTick(() => {
        if (this.$refs["myForm"]) {
          this.$refs["myForm"].clearValidate("employee_request.employee_id")
        }
      })
    },

    async countCheckTotalDayOffCheck(typeSubmmit, rowIndex, colIndex, rowIndexShift) {
      let countDayOffTick = 0;
      let countDayOffTickCurrentYear = 0;
      let countDayOffTickNextYear = 0;
      let data = await this.fn_handleDayOffTime();
      data.forEach((e,i) => {
        if (i != 0) return;
        e.forEach((x) => {
          let dayOffNumber = 1
          let dayOfWeek = new Date(MethodService.formatterMMDDYYYY(x.day)).getDay()
          const yearTicked = new Date(MethodService.formatterMMDDYYYY(x.day)).getFullYear();
          let day = x.work_days.find(item => item.name == (dayOfWeek + 2).toString())
          dayOffNumber = day && day.day_off_number ? day.day_off_number : 1
          if (
            x.odd_shifts.length == 1 &&
            x.odd_shifts[0] === 1
          ) {
            countDayOffTick += dayOffNumber;
            if (yearTicked && yearTicked == this.currentYear) {
              countDayOffTickCurrentYear += dayOffNumber;
            } else if (yearTicked && yearTicked == this.nextYear) {
              countDayOffTickNextYear += dayOffNumber;
            }
          } else if (x.odd_shifts.length == 2) {
            if (
              x.odd_shifts[0] === 1 &&
              x.odd_shifts[1] === 1
            ) {
              countDayOffTick += dayOffNumber;
              if (yearTicked && yearTicked == this.currentYear) {
                countDayOffTickCurrentYear += dayOffNumber;
              } else if (yearTicked && yearTicked == this.nextYear) {
                countDayOffTickNextYear += dayOffNumber;
              }
            } else if (
              (x.odd_shifts[0] === 1 &&
                x.odd_shifts[1] === 0) ||
              (x.odd_shifts[0] === 0 &&
                x.odd_shifts[1] === 1)
            ) {
              countDayOffTick += (dayOffNumber * 0.5);
              if (yearTicked && yearTicked == this.currentYear) {
                countDayOffTickCurrentYear += (dayOffNumber * 0.5);
              } else if (yearTicked && yearTicked == this.nextYear) {
                countDayOffTickNextYear += (dayOffNumber * 0.5);
              }
            }
          }
        })
      })
      let check = this.alertNotEnoughDayOff(countDayOffTickCurrentYear, countDayOffTickNextYear, rowIndexShift, rowIndex, colIndex, typeSubmmit)
      return check
    },

    alertNotEnoughDayOff(countDayOffTickCurrentYear, countDayOffTickNextYear, rowIndexShift, rowIndex, colIndex, typeSubmmit) {
      if (
        this.mData.dataForm.detail_request.type &&
        this.mData.dataForm.detail_request.type == 'LEAVE_WITH_PAY'
      ) {
        if (
          countDayOffTickCurrentYear > this.remain_allow_dayoff_number_current_year ||
          countDayOffTickNextYear > this.remain_allow_dayoff_number_next_year
        ) {
          window.toastr.warning(`Số ngày nghỉ có phép năm
            ${countDayOffTickCurrentYear > this.remain_allow_dayoff_number_current_year
              ? this.currentYear
              : countDayOffTickNextYear > this.remain_allow_dayoff_number_next_year
              ? this.nextYear
              : ''
            } còn lại không đủ để xin nghỉ`)
          if (typeSubmmit == 'checkBox') {
            this.dataTable[rowIndexShift][rowIndex].date[colIndex].value = 'false'
          }
          return true
        }
        return false
      }
      return false
    },
    async fn_checkDuplicateShiftOff(shiftId, date, rowIndex, colIndex, rowIndexShift) {
      // filter the duplicate day's shift
      let arr = []
      this.listReqDayOffToday.forEach((e) => {
        let arrB = e.dayoff_time.filter((x) => {
          return (
            x.shift_id == shiftId &&
            new Date(MethodService.formatterMMDDYYYY(date[colIndex].day)).getTime() ==
              new Date(x.day).getTime()
          )
        })
        if (arrB.length > 0) {
          arr = arr.concat(arrB)
        }
      })
      // Set checkbox to 'false' if this day's shift is duplicate
      if (arr.length > 0) {
        await this.fn_handleDayOffTime()
        arr.forEach((e1) => {
          this.dayoff_timePost.forEach((e2) => {
            if (
              MethodService.formatDate(e1.day, 'date') ==
                MethodService.formatDate(e2.day, 'date') &&
              e1.shift_id == e2.shift_id
            ) {
              e1.odd_shifts.find((val1, i1, arr1) => {
                e2.odd_shifts.find((val2, i2, arr2) => {
                  if (arr1[rowIndex] == 1 && arr2[rowIndex] == 1) {
                    window.toastr.warning('Hôm nay ca này đã xin nghỉ rồi')
                    this.dataTable[rowIndexShift][rowIndex].date[colIndex].value =
                      'false'
                    return
                  }
                })
              })
            }
          })
        })
      }
    },

    fn_checkHasShiftAndNumberWordDay(day, shiftWordDay) {
      const iteration =
        shiftWordDay && shiftWordDay.iteration_cycle ? shiftWordDay.iteration_cycle : ''
      const weekNumOfYear = this.fn_getWeekNumOfYear(day)
      const weekNumOfMonth = this.fn_getWeekNumOfMonth(day)
      const lastWeekNum = this.fn_getWeekNumOfMonth(
        new Date(new Date(day).getFullYear(), new Date(day).getMonth() + 1, 0)
      )
      const nearLastWeekNum =
        this.fn_getWeekNumOfMonth(
          new Date(new Date(day).getFullYear(), new Date(day).getMonth() + 1, 0)
        ) - 1
      if (
        shiftWordDay && shiftWordDay.number_word_day &&
        (iteration == 'WEEKLY' ||
        (iteration == 'EVEN_WEEK_OF_MONTH' && weekNumOfYear % 2 == 0) ||
        (iteration == 'ODD_WEEK_OF_MONTH' && weekNumOfYear % 2 != 0) ||
        (iteration == 'WEEK_1_OF_MONTH' && weekNumOfMonth == 1) ||
        (iteration == 'WEEK_2_OF_MONTH' && weekNumOfMonth == 2) ||
        (iteration == 'WEEK_3_OF_MONTH' && weekNumOfMonth == 3) ||
        (iteration == 'WEEK_4_OF_MONTH' && weekNumOfMonth == 4) ||
        (iteration == 'WEEK_5_OF_MONTH' && weekNumOfMonth == 5) ||
        (iteration == 'NEAR_LAST_WEEK_OF_MONTH' && weekNumOfMonth == nearLastWeekNum) ||
        (iteration == 'LAST_WEEK_OF_MONTH' && weekNumOfMonth == lastWeekNum))
      ) {
        return true
      } else {
        return false
      }
    },

    buildDataTable(listShift, listDay, listDayOff = []) {
      let dataTable = [];
      if (!listShift || !listDay) {
        return dataTable;
      }
      dataTable = listShift.map((shift) => {
        let listItem = [];
        for (let i = 0; i < shift.ten_ca.length; i++) {
          let item = {
            shift_id: shift.shift_id,
            shift_oddName: shift.ten_ca[i],
            work_days: shift.work_days,
          };
          listItem.push(item);
        }
        for (let i = 0; i < listItem.length; i++) {
          listItem[i].date = [];
          listDay.forEach((day) => {
            const dayOfWeek = day.getDay() == 0 ? '8' : day.getDay() + 1;
            const shiftWordDay = shift.work_days.find((e) => e.name == dayOfWeek); // Get periodTime of day
            const flag = this.fn_checkHasShiftAndNumberWordDay(day, shiftWordDay);
            let periodTime = [
              { start_time: {}, end_time: {} },
              { start_time: {}, end_time: {} },
            ];
            if (shiftWordDay && flag) {
              periodTime = shiftWordDay.period_time;
            }
            this.fn_setValueDefaultTable(shift, day, periodTime, listDay, listItem[i]);
          });
        }
        return listItem;
      });
      this.fn_checkDuplicateHoliday(dataTable);
      return dataTable;
    },

    fn_setValueDefaultTable(shift, day, periodTime, listDay, itemOfList) {
      let dayFormatted = MethodService.formatDate(day, 'date');
      let value = null;
      let eachDay = new Date(day).getTime();

      if (shift.start_time && shift.end_time) {
        let d_startLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.start_time)
        ).getTime();
        let d_endLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.end_time)
        ).getTime();
        if (shift.ten_ca.length == 1) {
          const hasStartTimeShift = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift = Object.keys(periodTime[0].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (
              eachDay >= d_startLimit &&
              eachDay <= d_endLimit &&
              hasStartTimeShift !== 0 &&
              hasEndTimeShift !== 0
            ) {
              value = 'false'; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        } else if (shift.ten_ca.length == 2) {
          const hasStartTimeShift1 = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift1 = Object.keys(periodTime[0].end_time).length;
          const hasStartTimeShift2 = Object.keys(periodTime[1].start_time).length;
          const hasEndTimeShift2 = Object.keys(periodTime[1].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (
              eachDay >= d_startLimit &&
              eachDay <= d_endLimit &&
              hasStartTimeShift1 !== 0 &&
              hasEndTimeShift1 !== 0 &&
              hasStartTimeShift2 !== 0 &&
              hasEndTimeShift2 !== 0
            ) {
              value = 'false'; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        }
      } else if (shift.start_time && !shift.end_time) {
        let d_startLimit = new Date(
          MethodService.formatterYYYYMMDD(shift.start_time)
        ).getTime();
        if (shift.ten_ca.length == 1) {
          const hasStartTimeShift = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift = Object.keys(periodTime[0].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (
              eachDay >= d_startLimit &&
              hasStartTimeShift !== 0 &&
              hasEndTimeShift !== 0
            ) {
              value = 'false'; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        } else if (shift.ten_ca.length == 2) {
          const hasStartTimeShift1 = Object.keys(periodTime[0].start_time).length;
          const hasEndTimeShift1 = Object.keys(periodTime[0].end_time).length;
          const hasStartTimeShift2 = Object.keys(periodTime[1].start_time).length;
          const hasEndTimeShift2 = Object.keys(periodTime[1].end_time).length;
          for (let i = 0; i < listDay.length; i++) {
            if (
              eachDay >= d_startLimit &&
              hasStartTimeShift1 !== 0 &&
              hasEndTimeShift1 !== 0 &&
              hasStartTimeShift2 !== 0 &&
              hasEndTimeShift2 !== 0
            ) {
              value = 'false'; // 0: đi làm/ 1: nghỉ
            } else {
              value = null;
            }
          }
        }
      }
      let o = { day: dayFormatted, value };
      itemOfList.date.push(o);
    },

    fn_checkDuplicateHoliday(dataTable) {
      dataTable.forEach((item) => {
        let dayConsider; //ngày xét có trùng ngày nghỉ quốc tế không
        for (let i = 0; i < item.length; i++) {
          for (let j = 0; j < item[i].date.length; j++) {
            for (let z = 0; z < this.listDayOffNotToReq.length; z++) {
              dayConsider = item[i].date[j].day.includes(this.listDayOffNotToReq[z]);
              if (dayConsider) {
                item[i].date[j].value = null; // trùng thì xét giá trị 'null' và không sinh ra ô xin nghỉ
              }
            }
          }
        }
      });
    },

    async fn_initDataShift() {
      await this.fn_getListEmployeeApprovedQLTT(this.mData.dataForm.employee_request.employee_id, false);
      this.fn_getEmployeeDayOff(this.mData.dataForm.employee_request.employee_id);
      this.fn_getReqDayOffToday(this.mData.dataForm.employee_request.employee_id);
      this.isShowTableDayOff = false;
      this.mData.dataForm.detail_request = {
        start_date: undefined,
        end_date: undefined,
      };
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? '&' : '') +
          (this.mData.dataForm.employee_request.employee_id
            ? 'employee_id=' + this.mData.dataForm.employee_request.employee_id
            : ''),
        fields: 'shift_id,start_time,end_time',
      };
      this.mData.tableRules.data = []; //reset data
      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        this.mData.tableRules.data = this.fn_getValidShiftInfo(res.result);
        this.mData.tableRules.data.reverse();
        this.mData.tableRules.data = await this.fn_changeData(this.mData.tableRules.data);
        if (
          this.mData.tableRules.data.length == 0 &&
          this.mData.dataForm.employee_request.employee_id
        ) {
          window.toastr.warning('Nhân viên hiện không có ca hiệu lực để tạo yêu cầu');
        }
      }
    },

    fn_getValidShiftInfo(shifts) {
      let curentTime = new Date().getTime()
      return shifts.filter((e) => {
        if (e.end_time) {
          return (
            (new Date(e.start_time).getTime() <= curentTime || new Date(e.start_time).getTime() > curentTime) &&
            curentTime <= new Date(e.end_time).getTime()
          );
        } else {
          return new Date(e.start_time).getTime() <= curentTime;
        }
      })
    },

    async fn_checkValidShift() {
      let dataFilter = {
        filters:
          this.mData.tableRules.filters +
          (this.mData.tableRules.filters ? '&' : '') +
          (this.mData.dataForm.employee_request.employee_id
            ? 'employee_id=' + this.mData.dataForm.employee_request.employee_id
            : ''),
        fields: 'shift_id,start_time,end_time',
      };
      this.mData.tableRules.data = []; //reset data
      this.isShowTableDayOff = false;
      let res = await EmployeeShiftApi.list(dataFilter);
      if (res.result) {
        const currentTime = new Date().getTime();
        const startTimeSelect = new Date(
          this.mData.dataForm.detail_request.start_date
        ).getTime();
        const endTimeSelect = new Date(
          this.mData.dataForm.detail_request.end_date
        ).getTime();
        res.result.forEach((el) => {
          if (el.start_time && el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            const endTime = new Date(el.end_time).getTime();
            if (
              (currentTime >= startTime && currentTime <= endTime) ||
              (startTimeSelect < startTime && endTimeSelect >= startTime) ||
              (startTimeSelect >= startTime &&
                startTimeSelect <= endTime &&
                endTimeSelect >= startTime) ||
              (startTimeSelect == endTime && endTimeSelect >= endTime)
            ) {
              this.mData.tableRules.data.push(el);
            }
          } else if (el.start_time && !el.end_time) {
            const startTime = new Date(el.start_time).getTime();
            if (
              currentTime >= startTime ||
              (startTimeSelect < startTime && endTimeSelect >= startTime) ||
              (startTimeSelect >= startTime && endTimeSelect >= startTime)
            ) {
              this.mData.tableRules.data.push(el);
            }
          }
        });
        this.mData.tableRules.data.reverse();
        this.mData.tableRules.data = await this.fn_changeData(this.mData.tableRules.data);
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let shiftIds = [];
      shiftIds = MethodService.findListItemDifferent(resData, 'shift_id');
      const shiftApiRes = await ShiftApi.list({
        limit: shiftIds.length,
        filters: 'id:in:' + shiftIds.join(','),
      });
      let ShiftList = shiftApiRes.result;
      if (ShiftList.length > 0) {
        resData.forEach((item) => {
          if (item.start_time && item.end_time) {
            item.start_time = MethodService.formatDate(item.start_time, 'date');
            item.end_time = MethodService.formatDate(item.end_time, 'date');
            let caLamViec = ShiftList.find((element) => {
              return element.id == item.shift_id;
            });
            item.work_days = caLamViec.work_days;
            if (caLamViec) {
              if (caLamViec.is_odd_shift) {
                let shiftOddNames = caLamViec.odd_names.map((el) => {
                  return el + ' (' + caLamViec.name + ')';
                });
                item.ten_ca = shiftOddNames;
              } else {
                item.ten_ca = [caLamViec.name];
              }
            } else {
              item.ten_ca = '';
            }
          } else if (item.start_time && !item.end_time) {
            item.start_time = MethodService.formatDate(item.start_time, 'date');
            let caLamViec = ShiftList.find((element) => {
              return element.id == item.shift_id;
            });
            item.work_days = caLamViec.work_days;
            if (caLamViec) {
              if (caLamViec.is_odd_shift) {
                let shiftOddNames = caLamViec.odd_names.map((el) => {
                  return el + ' (' + caLamViec.name + ')';
                });
                item.ten_ca = shiftOddNames;
              } else {
                item.ten_ca = [caLamViec.name];
              }
            } else {
              item.ten_ca = '';
            }
          }
        });
        return resData;
      } else {
        return (resData = []);
      }
    },

    // Select time from to
    async fn_tableSearch() {
      if (!this.mData.dataForm.employee_request.employee_id) {
        window.toastr.warning('Vui lòng chọn nhân viên trước khi chọn thời gian');
        if (this.mData.dataForm.detail_request.start_date) {
          this.mData.dataForm.detail_request.start_date = undefined;
        } else if (this.mData.dataForm.detail_request.end_date) {
          this.mData.dataForm.detail_request.end_date = undefined;
        }
      }
      let startTime = '';
      let endTime = '';
      if (this.mData.dataForm.detail_request.start_date) {
        startTime = new Date(this.mData.dataForm.detail_request.start_date).getTime();
      }
      if (this.mData.dataForm.detail_request.end_date) {
        endTime = new Date(this.mData.dataForm.detail_request.end_date).getTime();
      }

      if (startTime && endTime && startTime > endTime) {
        this.mData.dataForm.detail_request.end_date = undefined;
        window.toastr.warning('Mốc "tới" phải là lớn hơn hoặc bằng mốc "Thời gian từ"');
      }

      if (
        !this.mData.dataForm.detail_request.start_date ||
        !this.mData.dataForm.detail_request.end_date
      ) {
        this.isShowTableDayOff = false;
        return;
      } else if (
        this.mData.dataForm.detail_request.start_date &&
        this.mData.dataForm.detail_request.end_date
      ) {
        // Check đã cấu hình số ngày nghỉ phép hay chưa với trường hợp xin nghỉ vắt giữa 2 năm
        if (
          new Date(this.mData.dataForm.detail_request.start_date).getFullYear() != this.mData.dataForm.detail_request.end_date.getFullYear() &&
          this.remain_allow_dayoff_number_next_year == null &&
          this.mData.dataForm.detail_request.type == 'LEAVE_WITH_PAY'
        ) {
          this.isShowTableDayOff = false;
          this.mData.dataForm.detail_request.end_date = undefined;
          window.toastr.warning(`Bạn chưa cấu hình số ngày nghỉ có phép cho năm ${this.nextYear}`);
          return;
        }
        this.listDate = this.fn_getListDate(
          this.mData.dataForm.detail_request.start_date,
          this.mData.dataForm.detail_request.end_date
        );
        await this.fn_checkValidShift();
        if (this.mData.tableRules.data.length > 0) {
          this.dataTable = await this.buildDataTable(
            this.mData.tableRules.data,
            this.listDate
          );
          this.fn_setHeaderTable(this.dataTable);
          this.isShowTableDayOff = true;
        } else {
          window.toastr.warning('Nhân viên hiện không có ca hiệu lực để tạo yêu cầu');
        }
      }
    },

    fn_handleDayOffTime() {
      let dayoff_time = [];
      let shiftOffEachDay;
      dayoff_time = this.dataTable.map((shift) => {
        for (let i = 0; i < shift.length; i++) {
          for (let j = 0; j < shift[i].date.length; j++) {
            let valueOff = [];
            let valueInt;
            if (shift[i].date[j].value === 'true') {
              valueInt = 1;
            } else if (
              shift[i].date[j].value === 'false' ||
              shift[i].date[j].value === null
            ) {
              valueInt = 0;
            }
            let dayValueOff = dayoff_time.find(
              (x) => x.shift_id === shift[i].shift_id && x.day === shift[i].date[j].day
            );
            if (dayValueOff) {
              dayValueOff.odd_shifts.push(valueInt);
            } else {
              valueOff.push(valueInt);
              shiftOffEachDay = {
                work_days: shift[i].work_days,
                shift_id: shift[i].shift_id,
                day: shift[i].date[j].day,
                odd_shifts: valueOff,
              };
              dayoff_time.push(shiftOffEachDay);
            }
          }
        }
        return dayoff_time;
      });

      this.dayoff_timePost = [];
      this.fn_formatDayOffTimePost(shiftOffEachDay, dayoff_time[0]);
      this.dayoff_timePost = this.dayoff_timePost.filter((item) => {
        const d = MethodService.formatDate(item.day, 'date');
        if (this.listDayOffNotToReq.includes(d) == false) {
          return item;
        }
      })
      return dayoff_time
    },

    fn_formatDayOffTimePost(shiftOffEachDay, dayOffTime) {
      this.dayoff_timePost = dayOffTime.map((item) => {
        let dayFm = MethodService.formatterMMDDYYYY(item.day);
        let m = new Date(dayFm);
        //format to datetime
        let dateString = m;
        m.getUTCFullYear() +
          '/' +
          (m.getUTCMonth() + 1) +
          '/' +
          m.getUTCDate() +
          'T' +
          m.getUTCHours() +
          ':' +
          m.getUTCMinutes() +
          ':' +
          m.getUTCSeconds();
        shiftOffEachDay = {
          shift_id: item.shift_id,
          day: dateString,
          odd_shifts: item.odd_shifts,
        };
        return shiftOffEachDay;
      });
    },

    fn_validateTableDayOff() {
      // Validate to have at least 1 dayoff
      this.hasTimeOff = false;
      this.dayoff_timePost.forEach((el) => {
        if (el && el.odd_shifts.includes(1)) {
          this.hasTimeOff = true;
          return this.hasTimeOff;
        }
      });
      if (!this.hasTimeOff) {
        window.toastr.warning('Phải chọn ít nhất một ca nghỉ để tạo yêu cầu');
      }
    },

    fn_cleanDataDayOff() {
      // Check to have at least 1 dayoff
      let dataDayOff = [];
      this.dayoff_timePost.forEach((el) => {
        if (el && el.odd_shifts.includes(1)) {
          dataDayOff.push(el);
        }
      });
      return dataDayOff;
    },

    fn_groupBy(arr, key) {
      return arr.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x.odd_shifts);
        return rv;
      }, {});
    },

    fn_showCreateDayOffError(error) {
      const result = error && error.result ? error.result : null;
      if (result && result.error_code == 'INSUFFICIENT_ANNUAL_LEAVE') {
        window.toastr.warning(
          `Không đủ phép năm ${result.year}. ` +
          `Còn lại ${result.remaining_days} ngày, ` +
          `${result.held_days} ngày đang chờ duyệt, ` +
          `có thể sử dụng ${result.available_days} ngày. ` +
          `Đơn này yêu cầu ${result.requested_days} ngày.`
        );
        return;
      }

      const message =
        (result && result.message) ||
        (error && error.meta && error.meta.field) ||
        (error && error.detail) ||
        (error && error.message) ||
        'Không thể tạo yêu cầu. Vui lòng thử lại.';
      window.toastr.error(message);
    },

    fn_submitForm(type) {
      this.$refs['myForm'].validate(async (valid) => {
        if (valid) {
          try {
            const checkResults = await Promise.all([
              this.countCheckTotalDayOffCheck('submit')
            ]);
            if (checkResults[0] == true) return;

            await this.fn_handleDayOffTime();
            await this.fn_validateTableDayOff();
            let listApprovalUser = [];
            listApprovalUser = [
              {
                approval_user_id: this.mData.dataForm.employee_request.level2Approval,
              },
              {
                approval_user_id: this.mData.dataForm.employee_request.employeeApproval,
              },
            ];
            this.mData.dataForm.employee_request.title = this.mData.dataForm.employee_request.title.trim();
            this.mData.dataForm.employee_request.content = this.mData.dataForm.employee_request.content.trim();
            this.mData.dataForm.employee_request.company_id = this.currentCompany.id;
            this.mData.dataForm.employee_request.approval_users = listApprovalUser;
            this.mData.dataForm.employee_request.is_sequential = true;
            this.mData.dataForm.employee_request.approval_level = 2;
            this.mData.dataForm.detail_request.dayoff_time = await this.fn_cleanDataDayOff();

            let dataEmployeeRequest = this.mData.dataForm.employee_request;
            let dataEmployeeRequestDetail = this.mData.dataForm.detail_request;
            if (type == 'create' && this.hasTimeOff) {
              const availabilityResponse =
                await EmployeeRequestApi.CheckAnnualLeaveAvailability({
                  company_id: dataEmployeeRequest.company_id,
                  employee_id: dataEmployeeRequest.employee_id,
                  type: dataEmployeeRequestDetail.type,
                  dayoff_time: dataEmployeeRequestDetail.dayoff_time,
                });
              if (
                availabilityResponse.result &&
                !availabilityResponse.result.available
              ) {
                this.fn_showCreateDayOffError({
                  result: availabilityResponse.result,
                });
                return;
              }

              const res = await EmployeeRequestApi.create(dataEmployeeRequest);
              dataEmployeeRequestDetail.id = res.result;
              await EmployeeRequestDayOffApi.create(dataEmployeeRequestDetail);
              if (
                this.mData.dataDefault.listFeature.includes('FT1001') ||
                this.mData.dataDefault.listFeature.includes('FT1002')
              ) {
                this.$router.push({
                  name: 'Admin-ManageRequests-RequestsWaitingForApproval',
                });
              }
              this.fn_resetForm();
              this.isShowTableDayOff = false;
              this.fn_checkHasEmployee();
            }
          } catch (error) {
            this.fn_showCreateDayOffError(error);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
  },

  async created() {
    this.mData.dataForm.employee_request.type = 'DAY_OFF';
    await this.fn_innitDataDefault();
    await this.fn_checkHasEmployee();
    this.fn_syncRequestOrgFilterByEmployee(
      this.mData.dataForm.employee_request.employee_id
    );
  },
  mounted() {
    this.$refs.title.focus();
  },
};
</script>
<style scoped src="../../../../assets/css/layout/Request.css"></style>
<style scoped>
::v-deep .el-form-item,
::v-deep .el-form-item__content,
::v-deep .el-input,
::v-deep .el-input-number,
::v-deep .el-select,
::v-deep .el-date-editor {
  width: 100%;
}
</style>
